function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { components } from "react-select";
import CloseIcon from "./close-icon";
import DropdownIcon from "./dropdown-icon";
import CheckmarkIcon from "./checkmark-icon";
import classNames from "classnames";
// Custom Option component with custom checkbox
export const Option = (props)=>{
    const { isSelected, label } = props;
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs(components.Option, _object_spread_props(_object_spread({}, props), {
            className: "multi-select-custom-option",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: classNames("custom-checkbox", {
                        selected: isSelected
                    }),
                    children: /*#__PURE__*/ _jsx(CheckmarkIcon, {})
                }),
                /*#__PURE__*/ _jsx("label", {
                    children: label
                })
            ]
        }))
    });
};
export const MultiValueRemove = (props)=>{
    return /*#__PURE__*/ _jsx(components.MultiValueRemove, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx(CloseIcon, {})
    }));
};
// taken from the docs: https://react-select.com/components search for "ClearIndicator"
export const ClearIndicator = (props)=>{
    const { children = /*#__PURE__*/ _jsx(CloseIcon, {}), getStyles, innerProps: { ref } } = props, restInnerProps = _object_without_properties(props.innerProps, [
        "ref"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({}, restInnerProps), {
        ref: ref,
        style: getStyles("clearIndicator", props),
        children: /*#__PURE__*/ _jsx("div", {
            className: "action-indicator",
            children: children
        })
    }));
};
// same as ClearIndicator
export const DropdownIndicator = (props)=>{
    const { children = /*#__PURE__*/ _jsx(DropdownIcon, {}), getStyles, innerProps: { ref } } = props, restInnerProps = _object_without_properties(props.innerProps, [
        "ref"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({}, restInnerProps), {
        ref: ref,
        style: getStyles("clearIndicator", props),
        children: /*#__PURE__*/ _jsx("div", {
            className: "action-indicator",
            children: children
        })
    }));
};
